/* GoLastyka PDP sections v3: reveal, count-up, card stack, "pick bundle" buttons. Vanilla, no deps. */
(function () {
  var d = document, html = d.documentElement;
  html.classList.add('glk-js'); window.glkReady = 1;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function qa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function q(s, r) { return (r || d).querySelector(s); }

  function countUp(el, spd) {
    var raw = el.getAttribute('data-glk-count') || '', to = parseFloat(raw.replace(/\s/g, '').replace(',', '.'));
    if (isNaN(to)) return;
    var dec = (raw.split(/[.,]/)[1] || '').length, sep = raw.indexOf(',') > -1 ? ',' : '.';
    var D = 1400 * spd, t0 = performance.now();
    function fmt(v) { return dec ? v.toFixed(dec).replace('.', sep) : String(Math.round(v)); }
    el.textContent = fmt(0);
    (function f(t) { var k = Math.min(1, (t - t0) / D), e = 1 - Math.pow(1 - k, 3); el.textContent = fmt(to * e); if (k < 1) requestAnimationFrame(f); })(t0);
  }

  function stack(sec, spd) {
    var s = q('[data-glk-stack]', sec);
    if (!s) return;
    var cards = qa('.sc[data-i]', s);
    var cnt = q('[data-glk-cnt]', sec), dots = q('[data-glk-dots]', sec), btn = q('[data-glk-next]', sec);
    if (!cards.length) return;
    var order = cards.map(function (c, i) { return i; }), busy = false;
    if (dots) dots.innerHTML = cards.map(function () { return '<i></i>'; }).join('');
    function paint() {
      order.forEach(function (ci, p) { cards[ci].setAttribute('data-p', Math.min(p, 3)); cards[ci].setAttribute('aria-hidden', p ? 'true' : 'false'); });
      if (cnt) cnt.textContent = (order[0] + 1) + ' / ' + cards.length;
      if (dots) qa('i', dots).forEach(function (x, j) { x.classList.toggle('on', j === order[0]); });
    }
    function next() {
      if (busy || cards.length < 2) return; busy = true;
      var top = cards[order[0]]; top.classList.add('gone');
      setTimeout(function () {
        top.classList.remove('gone'); order.push(order.shift());
        top.style.transition = 'none'; paint(); void top.offsetWidth; top.style.transition = ''; busy = false;
      }, RM ? 0 : 450 * spd);
    }
    function goTo(i) { var n = 0; while (order[0] !== i && n++ < cards.length) order.push(order.shift()); paint(); }
    sec._glkGoTo = goTo;
    if (btn) btn.onclick = next;
    var x0 = null;
    s.onpointerdown = function (e) { x0 = e.clientX; };
    s.onpointerup = function (e) { if (x0 !== null && Math.abs(e.clientX - x0) > 40) next(); x0 = null; };
    s.onpointercancel = function () { x0 = null; };
    paint();
    /* shrink long quotes until they fit their card (min 12px) */
    function fit() {
      cards.forEach(function (c) {
        var cap = q('.cap', c), qt = q('.q', c); if (!cap || !qt) return;
        qt.style.fontSize = '';
        var fs = parseFloat(getComputedStyle(qt).fontSize), n = 0;
        while ((qt.scrollHeight > qt.clientHeight + 1 || cap.scrollHeight > cap.clientHeight + 1) && fs > 12 && n++ < 20) { fs -= 0.5; qt.style.fontSize = fs + 'px'; }
      });
    }
    fit(); addEventListener('resize', fit); if (d.fonts && d.fonts.ready) d.fonts.ready.then(fit);
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (en) {
      var el = en.target;
      if (!en.isIntersecting && en.boundingClientRect.top > innerHeight) return;
      el.classList.add('is-in');
      var spd = parseFloat(getComputedStyle(el).getPropertyValue('--spd')) || 1;
      if (el.hasAttribute('data-glk-count')) countUp(el, spd);
      qa('[data-glk-count]', el).forEach(function (c) { countUp(c, spd); });
      io.unobserve(el);
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' }) : null;

  function init(sec) {
    if (!sec || sec._glk) return; sec._glk = 1;
    var spd = parseFloat(getComputedStyle(sec).getPropertyValue('--spd')) || 1;
    var still = RM || sec.classList.contains('glk--static') || !io;
    if (still) {
      sec.classList.add('glk--static');
      qa('[data-glk-in]', sec).forEach(function (el) { el.classList.add('is-in'); });
    } else {
      qa('[data-glk-in]', sec).forEach(function (el) {
        qa('[data-glk-count]', el).forEach(function (c) { c.textContent = '0'; });
        io.observe(el);
      });
    }
    stack(sec, spd);
    zones(sec, still);
    rail(sec);
  }

  /* zones before/after: tabs swap the pair, drag slider, one sweep when first seen and on every tab click */
  function zones(sec, still) {
    var ba = q('.zzba', sec); if (!ba) return;
    var inp = q('input', ba), tabs = qa('.tb', sec), pairs = qa('.pair', ba), res = qa('.zzres .r', sec);
    function setX(x) { ba.style.setProperty('--x', x + '%'); inp.value = x; }
    inp.addEventListener('input', function () { ba.style.setProperty('--x', inp.value + '%'); });
    function sweep() {
      if (still || RM) return;
      var t0 = performance.now(), lerp = function (a, b, k) { return a + (b - a) * k; };
      (function f(t) {
        var k = Math.min(1, (t - t0) / 1500);
        setX(k < .45 ? lerp(50, 88, k / .45) : lerp(88, 30, Math.min(1, (k - .45) / .55)));
        if (k < 1) requestAnimationFrame(f);
      })(t0);
    }
    function go(i, demo) {
      tabs.forEach(function (x, j) { x.classList.toggle('on', j === i); x.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      pairs.forEach(function (x, j) { x.classList.toggle('on', j === i); });
      res.forEach(function (x, j) { var on = j === i; x.classList.toggle('on', on); if (on) { x.classList.remove('zzf'); void x.offsetWidth; x.classList.add('zzf'); } });
      if (demo) { setX(50); sweep(); }
    }
    tabs.forEach(function (t, j) { t.addEventListener('click', function () { go(j, true); }); });
    sec._glkZone = function (i) { go(i, false); };
    if (!still && 'IntersectionObserver' in window) {
      var o = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { o.disconnect(); sweep(); } }, { threshold: .45 });
      o.observe(ba);
    }
  }

  /* card rail arrows (ingredients) */
  function rail(sec) {
    var r = q('[data-glk-rail]', sec); if (!r) return;
    var prev = q('[data-glk-prev]', sec), next = q('[data-glk-next-card]', sec);
    if (!prev || !next) return;
    function step() { var c = r.children[0]; if (!c) return r.clientWidth * .8; var g = parseFloat(getComputedStyle(r).columnGap) || 16; return c.getBoundingClientRect().width + g; }
    function upd() { var max = r.scrollWidth - r.clientWidth - 2; prev.disabled = r.scrollLeft <= 2; next.disabled = r.scrollLeft >= max; }
    prev.addEventListener('click', function () { r.scrollBy({ left: -step(), behavior: RM ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { r.scrollBy({ left: step(), behavior: RM ? 'auto' : 'smooth' }); });
    r.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
  }
  function initAll(root) { qa('.glk[data-glk]', root).forEach(init); satc(); }
  /* sticky add-to-cart: frosted bar + bottle (bottle is a sibling of the pill so the pill's overflow can't clip it) */
  function satc() {
    var bar = q('sticky-atc'); if (!bar || bar._glk) return; bar._glk = 1;
    var btn = q('.sticky-atc__button .button', bar); if (!btn) return;
    bar.classList.add('glk-satc');
    var src = window.glkBottle;
    if (src) {
      var wrap = d.createElement('span'); wrap.className = 'glk-sb-wrap';
      btn.parentNode.insertBefore(wrap, btn); wrap.appendChild(btn);
      var im = d.createElement('img'); im.className = 'glk-sb'; im.src = src; im.alt = ''; im.width = 31; im.height = 46; im.setAttribute('aria-hidden', 'true');
      wrap.appendChild(im);
      var done = false;
      var check = function () {
        if (done) return;
        var r = bar.getBoundingClientRect(), cs = getComputedStyle(bar);
        if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.top < innerHeight - 10 && r.height) {
          done = true; wrap.classList.add('glk-wig');
          removeEventListener('scroll', check, true);
        }
      };
      addEventListener('scroll', check, { passive: true, capture: true });
    }
  }


  /* in-page anchors (e.g. "ОЩЕ ОТЗИВИ" -> #otzivi): smooth scroll, no reload */
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || a.hasAttribute('data-glk-buy')) return;
    var href = a.getAttribute('href'), i = href.indexOf('#'), id = href.slice(i + 1);
    if (!id || (i > 0 && href.slice(0, i).replace(location.origin, '') !== location.pathname)) return;
    var t = d.getElementById(id);
    if (id === 'buy') t = q('quantity-breaks') || q('form[action*="/cart/add"]') || t;   /* every "#buy" button -> the bundle picker */
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: id === 'buy' ? 'center' : 'start' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });

  /* bundle buttons: select the N-pack in the buy box, then scroll to it */
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-glk-buy]');
    if (!a) return;
    var n = a.getAttribute('data-glk-buy'), target = null;
    if (n && n !== '0') {
      var r = q('input[type="radio"][name="quantity"][value="' + n + '"]');
      if (r) { if (!r.checked) r.click(); target = r.closest('quantity-breaks') || r.parentElement; }
      else {
        var sel = q('form[action*="/cart/add"] select[name="id"]');
        var pos = parseInt(n, 10) - 1;
        if (sel && sel.options[pos]) { sel.selectedIndex = pos; sel.dispatchEvent(new Event('change', { bubbles: true })); target = sel; }
      }
    }
    if (!target) target = q('quantity-breaks') || q('form[action*="/cart/add"]');
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' });
    }
  });

  /* bundle picker -> real bundle variant: "Вземи 2" adds 1 x the "2 опаковки" variant (its own price), not 2 x the single one */
  if (!window.glkBundleCart) {
    window.glkBundleCart = 1;
    d.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.getAttribute || (f.getAttribute('action') || '').indexOf('/cart/add') < 0) return;
      var idIn = f.querySelector('[name="id"]'), qb = q('quantity-breaks'), js = qb && q('script[type="application/json"]', qb);
      var r = (f.getAttribute('id') && q('input[name="quantity"][form="' + f.getAttribute('id') + '"]:checked')) || f.querySelector('input[name="quantity"]:checked');
      if (!idIn || !js || !r) return;
      var n = parseInt(r.value, 10), vs;
      try { vs = JSON.parse(js.textContent); } catch (x) { return; }
      if (!(n > 1) || !vs || !vs[n - 1] || !vs[0] || String(vs[0].id) !== String(idIn.value) || vs[n - 1].available === false) return;
      var oldId = idIn.value, oldQ = r.value;
      idIn.value = vs[n - 1].id; r.value = '1';
      setTimeout(function () { idIn.value = oldId; r.value = oldQ; }, 2500);
    }, true);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  d.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  d.addEventListener('shopify:block:select', function (e) {
    var sec = e.target.closest && e.target.closest('.glk');
    if (sec && sec._glkGoTo && e.target.hasAttribute('data-i')) sec._glkGoTo(parseInt(e.target.getAttribute('data-i'), 10));
    if (sec && sec._glkZone && e.target.classList.contains('tb')) sec._glkZone(parseInt(e.target.getAttribute('data-i'), 10));
    if (sec && e.target.scrollIntoView && e.target.closest('.rail')) e.target.scrollIntoView({ block: 'nearest', inline: 'center' });
  });
  d.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();
